import { render, staticRenderFns } from "./Pagella.vue?vue&type=template&id=413f3674&scoped=true&"
import script from "./Pagella.vue?vue&type=script&lang=js&"
export * from "./Pagella.vue?vue&type=script&lang=js&"
import style0 from "./Pagella.vue?vue&type=style&index=0&id=413f3674&prod&lang=css&"
import style1 from "./Pagella.vue?vue&type=style&index=1&id=413f3674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f3674",
  null
  
)

export default component.exports